import type { McpConnection } from './api';

/** Connector Access presentation helpers (pages/mcp-connections). */

export const MCP_STATUS_LABEL: Record<McpConnection['status'], string> = {
  connected: 'Connected',
  not_connected: 'Not connected',
  revoked: 'Revoked',
};

/** The Approved cell. approved_at is recorded from 2026-10-23, so a listed
 *  connection approved before then (it still holds a live token) has none:
 *  that reads "Not recorded", never "Never", which would be false. */
export const MCP_APPROVAL_NOT_RECORDED = 'Not recorded';

export function mcpApprovedText(approvedAt: string | null, format: (iso: string) => string): string {
  return approvedAt ? format(approvedAt) : MCP_APPROVAL_NOT_RECORDED;
}

/** The later of last use and last refresh, or null when neither happened. */
export function mcpLastActivity(c: Pick<McpConnection, 'last_used_at' | 'last_refresh_at'>): string | null {
  const times = [c.last_used_at, c.last_refresh_at].filter((t): t is string => !!t);
  if (times.length === 0) return null;
  return times.reduce((a, b) => (Date.parse(a) >= Date.parse(b) ? a : b));
}

/** Live connections first (as the Api orders them), revoked ones apart. */
export function splitMcpConnections(connections: McpConnection[]): { live: McpConnection[]; revoked: McpConnection[] } {
  return {
    live: connections.filter((c) => c.status !== 'revoked'),
    revoked: connections.filter((c) => c.status === 'revoked'),
  };
}

/** What the page says after a revoke. */
export function mcpRevokeNotice(name: string, alreadyRevoked: boolean): string {
  return alreadyRevoked ? `${name} was already revoked.` : `Revoked ${name}. Its access ends within a minute.`;
}
